import { Breadcrumb, Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import React from 'react';
export const BreadcrumbRenderer = (breadcrumbProps) => {
    const classes = classNames(Classes.BREADCRUMB, {
        [Classes.BREADCRUMB_CURRENT]: breadcrumbProps.current,
        [Classes.DISABLED]: breadcrumbProps.disabled,
    }, breadcrumbProps.className);
    if (breadcrumbProps.href) {
        return (React.createElement(Link, { className: classes, to: breadcrumbProps.href, onClick: breadcrumbProps.disabled ? undefined : breadcrumbProps.onClick, tabIndex: breadcrumbProps.disabled ? undefined : 0, target: breadcrumbProps.target }, breadcrumbProps.text));
    }
    return React.createElement(Breadcrumb, Object.assign({}, breadcrumbProps));
};
//# sourceMappingURL=BreadcrumbRouterRenderer.js.map